module.exports = __webpack_public_path__ + "static/media/button-arrow-right-disabled.ca63a87b.svg";